import workspaceQuery from 'graphql/queries/nominal/NominalSupplierAccountSetWorkspaceQuery.graphql';
import listQuery from 'graphql/queries/nominal/NominalSupplierAccountSetListQuery.graphql';
import instanceQuery from 'graphql/queries/nominal/NominalSupplierAccountSetQuery.graphql';
import defaultQuery from 'graphql/queries/nominal/NominalSupplierAccountSetDefault.graphql';
import mutationQuery from 'graphql/mutations/nominal/NominalSupplierAccountSetMutation.graphql';
import fragment from 'graphql/fragments/nominal/NominalSupplierAccountSetFragment.graphql';

const NominalSupplierAccountSet = {
  type: 'NominalSupplierAccountSet',
  title: 'Supplier Account Sets',
  formTitle: 'Supplier Account Set',
  formUrl: '/Nominal/SupplierAccountSet/Details/',
  workspaceUrl: '/Nominal/SupplierAccountSet/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  default: defaultQuery,
  update: mutationQuery,
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'code',
  },
  fragment,
  screenReference: 'NOMINAL_SUPPLIER_ACCOUNT_SET',
};

export default NominalSupplierAccountSet;
